import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const ADMIN_AFFILIATE_TRACKERS_SETTINGS_SUBAFFILIATE_CONDITION_MAIN_ROUTE_NAME = Symbol('admin.affiliates.approved.trackers-settings.main-subaffiliate-condition');
export const ADMIN_AFFILIATE_TRACKERS_SETTINGS_SUBAFFILIATE_CONDITION_ROUTE_NAME = Symbol('admin.affiliates.approved.trackers-settings.subaffiliate-condition');

export const TRANSLATION_GROUP_AFFILIATES_TRACKERS_SETTINGS_SUBAFFILIATE_CONDITION = Symbol('admin.affiliates.approved.trackers-settings.subaffiliate-condition');

export const AFFILIATE_SHOW_SUBAFFILIATE_CONDITION_QUERY = 'affiliate.show-subaffiliate-condition';
export const AFFILIATE_SHOW_SUBAFFILIATE_CONDITION_API_URL = 'admin/affiliates/:id/show_subaffiliate_condition';

export const AFFILIATE_CREATE_SUBAFFILIATE_CONDITION_MUTATION = 'affiliate.create-subaffiliate-condition';
export const AFFILIATE_CREATE_SUBAFFILIATE_CONDITION_API_URL = 'admin/history_of_subaffiliates_changes';

export const AFFILIATE_DELETE_SUBAFFILIATE_CONDITION_MUTATION = 'affiliate.delete-subaffiliate-condition';
export const AFFILIATE_DELETE_SUBAFFILIATE_CONDITION_API_URL = 'admin/history_of_subaffiliates_changes/:itemId';

export const AFFILIATE_SUBAFFILIATE_SETTINGS = {
  HISTORY_CHANGES_CREATE: new Permission(
    PermissionsList.admin.HISTORYOFSUBAFFILIATESCHANGES_CREATE,
  ),
  HISTORY_CHANGES_EDIT: new Permission(
    PermissionsList.admin.HISTORYOFSUBAFFILIATESCHANGES_EDIT,
  ),
  HISTORY_CHANGES_DELETE: new Permission(
    PermissionsList.admin.HISTORYOFSUBAFFILIATESCHANGES_DELETE,
  ),
};
